import {inject, NgZone} from "@angular/core";

export const customSetTimeout = (callback:any, timer:any = 0): any => {
  if(typeof window !== 'undefined'){
    return setTimeout(callback, timer)
  }
  return undefined;
}

export const customSetInterval = (callback:any, timer:any): any => {
  if(typeof window !== 'undefined'){
    //return inject(NgZone).runOutsideAngular(() => {
    return setInterval(callback, timer)
   // })
  }
  return undefined;
}

